export default __webpack_public_path__ + "static/media/2S.294a87fa.webp";